import React from 'react';
import './title.style.scss';
type TRoleTitleProps = {
  children: React.ReactNode,

}
const RoleTitle = ({ children }: TRoleTitleProps) => {
  return (
    <>
      <p className="shop-roles-title">{children}</p>
    </>
  );
};

export default RoleTitle;
